import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { api } from '../../app/api'
import { normalizeEventsResponse } from '../../utils/calendarEventUtils'

export const fetchEvents = createAsyncThunk(
    'events/fetchEvents',
    async ({ formatDate }, { rejectWithValue }) => {
        try {
            const response = await api.get(`/event/getDate/${formatDate}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
export const fetchEvent = createAsyncThunk(
    'events/fetchEvent',
    async ({ id }, { rejectWithValue }) => {
        try {
            api.defaults.headers = {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
            const response = await api.get(`/event/${id}`)
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)
export const fetchRangeEvents = createAsyncThunk(
    'events/fetchRangeEvents',
    async ({ type }) => {
        const data = {
            range: 10,
            direction: type
        }
        api.defaults.headers = {
            Authorization: `Bearer ${localStorage.getItem('token')}`
        }

        const response = await api.post(`/event/range-date/filter`, data);
        return response.data
    }
)

/** Same source as mobile GET /v1/events — full list; filter by date client-side */
export const fetchAllEvents = createAsyncThunk(
    'events/fetchAllEvents',
    async (_, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('token')
            if (token) {
                api.defaults.headers = {
                    ...api.defaults.headers,
                    Authorization: `Bearer ${token}`,
                }
            }
            const response = await api.get('/events')
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

const calendarSlice = createSlice({
    name: 'calendar',
    initialState: {
        isLoaded: false,
        eventLoaded: false,
        events: [],
        /** Normalized list from GET /events (mobile parity) */
        eventsList: [],
        allEvents: {},
        event: {},
        error: {
            failed: false,
            message: null,
        },
    },
    extraReducers: {
        [fetchEvents.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchEvents.fulfilled]: (state, action) => {
            state.events = action.payload
            state.isLoaded = true;
        },
        [fetchEvents.rejected]: (state, action) => {
            state.isLoaded = true;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchEvent.pending]: (state) => {
            state.eventLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchEvent.fulfilled]: (state, action) => {
            state.event = action.payload[0]
            state.eventLoaded = true;
        },
        [fetchEvent.rejected]: (state, action) => {
            state.eventLoaded = true;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchRangeEvents.pending]: (state) => {
            state.isLoaded = false;
            state.error.failed = false;
            state.error.message = null;
        },
        [fetchRangeEvents.fulfilled]: (state, action) => {
            state.events = action.payload
            state.isLoaded = true;
        },
        [fetchRangeEvents.rejected]: (state, action) => {
            state.isLoaded = true;
            state.error.message = action.payload;
            state.error.failed = true;
        },
        [fetchAllEvents.pending]: (state) => {
            state.isLoaded = false
            state.error.failed = false
            state.error.message = null
        },
        [fetchAllEvents.fulfilled]: (state, action) => {
            const raw = action.payload
            const list = normalizeEventsResponse(raw)
            state.eventsList = list
            state.events = list
            state.allEvents = raw && typeof raw === 'object' && !Array.isArray(raw) ? raw : {}
            state.isLoaded = true
        },
        [fetchAllEvents.rejected]: (state, action) => {
            state.isLoaded = true
            state.error.message = action.payload
            state.error.failed = true
        },
    }
})

export default calendarSlice.reducer
